/* Даты и подписи кабинета. Даты — строки YYYY-MM-DD в часовом поясе тренера. */

let TZ = 'Europe/Moscow';
export const setTz = (tz: string | null | undefined) => {
  if (tz) TZ = tz;
};
/** Сегодня в часовом поясе тренера */
export const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
/** Дата события (timestamp) — в часовом поясе тренера */
export const dateOf = (ts: Date | string | null | undefined) =>
  !ts ? null : new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ts));

export const RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const DOW_LONG = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
export const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];

const D = (s: string) => new Date(s + 'T00:00:00');
const iso = (d: Date) => d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
export const addDays = (s: string, n: number) => {
  const d = D(s);
  d.setDate(d.getDate() + n);
  return iso(d);
};
/** 0 = понедельник */
export const dowMon = (s: string) => (D(s).getDay() + 6) % 7;
export const daysBetween = (a: string, b: string) => Math.round((D(b).getTime() - D(a).getTime()) / 86400000);
export const dm = (s: string) => {
  const d = D(s);
  return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0');
};
export const humanDate = (s: string) => {
  const d = D(s);
  return d.getDate() + ' ' + MONTHS[d.getMonth()];
};
export const dlong = (s: string) => {
  const d = D(s);
  return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
};
export const dshortMon = (s: string) => {
  const d = D(s);
  return d.getDate() + ' ' + MONTHS[d.getMonth()].slice(0, 3) + ' ' + d.getFullYear();
};
export const dshort = (s: string) => dm(s) + '.' + s.slice(0, 4);

export const plural = (n: number, a: string, b: string, c: string) => {
  const x = Math.abs(n) % 100,
    y = x % 10;
  return x > 10 && x < 20 ? c : y === 1 ? a : y > 1 && y < 5 ? b : c;
};

export const age = (born: string | null | undefined) => {
  if (!born) return null;
  const b = D(born),
    t = D(today());
  let a = t.getFullYear() - b.getFullYear();
  if (t.getMonth() < b.getMonth() || (t.getMonth() === b.getMonth() && t.getDate() < b.getDate())) a--;
  return a;
};

export function ago(date: string | null | undefined) {
  if (!date) return '—';
  const n = daysBetween(date, today());
  return n <= 0 ? 'сегодня' : n === 1 ? 'вчера' : n + ' ' + plural(n, 'день', 'дня', 'дней') + ' назад';
}

export const dayLabel = (d: string) => (d === today() ? 'Сегодня' : d === addDays(today(), -1) ? 'Вчера' : humanDate(d));

export const fmtNum = (v: number | string) => String(v).replace('.', ',');
export const parseNum = (v: string) => parseFloat(String(v).replace(',', '.'));

/** Инициалы человека: «Артём Ковалёв» → «АК» */
export const ini = (name: string) =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase() || '—';

/** Инициалы группы: «ЛФК» → «ЛФК», «ЛФК · утро» → «ЛУ» */
export const grpIni = (n: string) => {
  const w = String(n || '')
    .trim()
    .split(/[^а-яёa-z0-9]+/i)
    .filter(Boolean);
  return (w.length === 1 && w[0].length <= 3 ? w[0] : w.length > 1 ? w.slice(0, 3).map((x) => x[0]).join('') : (w[0] || 'Г').slice(0, 2)).toUpperCase();
};

/** Инициалы упражнения по английскому названию — превью без картинки */
export const exIni = (e: { en?: string; ru?: string }) =>
  (e.en || e.ru || '')
    .split(/[\s-]/)
    .slice(0, 2)
    .map((w) => w[0] || '')
    .join('')
    .toUpperCase();

export const rub = (n: number) => n.toLocaleString('ru-RU') + ' ₽';

/** Телефон для показа: +79131234567 → +7 913 123-45-67, другие страны — со своим кодом */
export { phoneView } from '@tg/domain';
